<template>
    <div>
        <div class="w-screen h-dvh max-w-full max-h-full bg-surface text-ink flex flex-col justify-center items-center">
            <!-- Content -->
            <div class="flex flex-col justify-around sm:justify-center items-center gap-10 w-full md:w-150 text-center py-4 px-10 overflow-x-hidden overflow-y-auto h-full">
                <div class="flex flex-col gap-5 justify-center items-center">
                    <GeneralCoachMarble class="size-15" />
                    <h1 class="flex md:flex-row flex-col">
                        <!-- Title -->
                        <template v-if="!isOutro">
                            <span class="display-serif text-ink">{{ t("feedback.response.landing.greeting") }}&nbsp;</span>
                            <span class="display-serif text-ink">{{ t("feedback.response.landing.coachTitle", { name: recipient_users_name }) }}</span>
                        </template>
                        <template v-else>
                            <span class="text-[48px]">{{ t("feedback.response.landing.outroTitle") }}</span>
                        </template>
                    </h1>
                    <template v-if="!isOutro">
                        <div class="body-small text-ink text-left w-full">
                            {{ t("feedback.response.landing.intro", { name: recipient_users_name }) }}
                        </div>
                    </template>
                    <template v-else>
                        <I18nT keypath="feedback.response.landing.outroBody" tag="div" class="body-small text-ink text-left mx-auto">
                            <template #lineBreak><br /></template>
                            <template #name>{{ recipient_users_name }}</template>
                        </I18nT>
                    </template>
                    <template v-if="!isOutro">
                        <div class="flex flex-wrap gap-2.5 text-ink justify-center items-center">
                            <BaseCard padding="sm" class="w-37.5 flex flex-col justify-center items-center gap-2">
                                <i class="bi bi-shield-lock" aria-hidden="true"></i>
                                <div class="body-small">{{ t("feedback.response.landing.anonymous") }}</div>
                            </BaseCard>
                            <BaseCard padding="sm" class="w-37.5 flex flex-col justify-center items-center gap-2">
                                <i class="bi bi-clock" aria-hidden="true"></i>
                                <div class="body-small">{{ t("feedback.response.landing.duration") }}</div>
                            </BaseCard>
                            <BaseCard padding="sm" class="w-37.5 flex flex-col justify-center items-center gap-2">
                                <i class="bi bi-journal-text" aria-hidden="true"></i>
                                <I18nT keypath="feedback.response.landing.speakNaturally" tag="div" class="body-small">
                                    <template #lineBreak><br /></template>
                                </I18nT>
                            </BaseCard>
                        </div>
                    </template>
                    <template v-else>
                        <BaseCard padding="sm" class="w-37.5 flex flex-col justify-center items-center gap-2">
                            <i class="bi bi-check-circle text-base/none" aria-hidden="true"></i>
                            <p class="body">{{ t("feedback.response.landing.sent") }}</p>
                        </BaseCard>
                    </template>
                </div>
                <template v-if="!isOutro">
                    <BaseButton :disabled="preview" theme="primary" class="w-75" @click="startChat">{{ t("feedback.response.landing.shareFeedback") }}</BaseButton>
                </template>
                <template v-else>
                    <BaseButton theme="primary" class="w-75" @click="openUrl('/accounts/login/')">{{ t("feedback.response.landing.loginButton") }}</BaseButton>
                </template>
            </div>
            <!-- Start of perceived footer -->
            <div v-if="!preview" class="hidden sm:block">
                <div class="grid grid-cols-3 gap-4 items-center mt-10 md:my-6 md:w-[60vw]">
                    <div>
                        <PrivacyDialog />
                    </div>
                    <div class="flex text-center justify-center items-center w-full gap-x-2">
                        <p class="text-ink-muted body-small-bold inline">{{ t("feedback.response.landing.madeBy") }}</p>
                        <img :src="ColorLogo" :alt="t('feedback.response.landing.logoAlt')" class="h-6 w-auto" />
                    </div>
                    <form class="flex flex-col gap-5 items-center">
                        <div class="gap-10 flex items-center justify-center">
                            <select
                                :aria-label="t('feedback.response.landing.languageSelectLabel')"
                                class="focus-field bg-transparent shrink-0 inline-block w-auto hover:text-control-text-strong text-control-text body-small">
                                <template v-for="opt in languageOptions" :key="opt[0]">
                                    <option :value="opt[0]" :selected="opt[0] === 'English'" v-text="opt[0]"></option>
                                </template>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import ColorLogo from "~img/color-logo.svg";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import GeneralCoachMarble from "~vue/components/navigation/CoachingModeMarbles/GeneralCoachMarble.vue";
import PrivacyDialog from "~vue/Onboarding/PrivacyDialog.vue";
import { openUrl } from "~vue/utils";
import { inject } from "vue";
import { I18nT, useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
    preview: {
        type: Boolean,
        default: false,
    },
    recipient_users_name: {
        type: String,
        default: "",
    },
    isOutro: {
        type: Boolean,
        default: false,
    },
});

const startChat = () => {
    emit("start-feedback-flow");
};
const emit = defineEmits(["start-feedback-flow"]);

const languageOptions = inject("languageOptions");
</script>
